import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const exportAllSubscribers = createAsyncThunk(
  "newsletter/exportAllSubscribers", 
  async () => {
    const response = await api.get("/newsletter/export", {
      responseType: "blob",
    });
    return response.data;
  }
);